import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/services/global.service';
import { ApiService } from 'src/app/services/api.service';
import { IonSelectCustomEvent } from '@ionic/core';
import { SelectChangeEventDetail } from '@ionic/angular';
import { SentimentAnalysisModelInferencingComponent } from '../components/sentiment-analysis-model-inferencing/sentiment-analysis-model-inferencing.component';

@Component({
  selector: 'app-sentiment-analysis-page',
  templateUrl: './sentiment-analysis-page.page.html',
  styleUrls: ['./sentiment-analysis-page.page.scss'],
})
export class SentimentAnalysisPagePage implements OnInit {

  textListData: any[] = []; // Full data from API

  // variables for footer
  totalPages: number = 5;
  currentPage: number = 1;
  pageSize: number = 20;
  pageSizeOptions = [20, 50, 100];

  //varialbes for Selection
  selectedOption !: string | null;
  options = [
      { label: 'Dutch', value: 'nl' },
      { label: 'English', value: 'en' },
  ];

  // varialbes for user details
  userName !: string | null;
  userLanguage !: string | null;
  userAccent !: string | null;
  userAge !: string | null;
  userGender !: string | null;
  userId !: string | null;

  constructor(
    private modalCtrl: ModalController,
    private apiService:ApiService,
    private router:Router,
    private globalService:GlobalService,
    private alertController: AlertController,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit() {
  }

  ionViewWillEnter() {
    console.log("Page Entered - Fetching Data");
    this.selectedOption = localStorage.getItem('langCategory') || 'nl';
    this.fetchTextList();

    //user details fetched from localstorage
    this.userName = localStorage.getItem('userName');
    this.userLanguage = localStorage.getItem('language');
    this.userAccent = localStorage.getItem('accent');
    this.userAge = localStorage.getItem('age');
    this.userGender = localStorage.getItem('gender');
    this.userId = localStorage.getItem('userId');

   


  }

  async ionViewWillLeave() {
    console.log("Ion View Will Leave Triggered");

    // Perform any cleanup tasks
    // Reset variables for different variables
    this.textListData = [];
    this.currentPage = 1;

    // Reset variables for filter
    localStorage.setItem('langCategory','nl'); // update the localStorage value for language
  }

  goToMenu() {
    this.router.navigate(['/menu']);
  }

  async openPopupForModelInferencing() {
    const modal = await this.modalCtrl.create({
      component: SentimentAnalysisModelInferencingComponent,
      backdropDismiss: false,  // Prevent closing when clicking outside
      cssClass: 'large-modal-1', //custom class for styling
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.fetchTextList();
    }else{
    }
  }

  fetchTextList() {
    this.globalService.logoutLoading(); // Show loading indicator
  
    try {
      const lang = this.selectedOption || localStorage.getItem('language') || 'nl';
      const current_page = this.currentPage || localStorage.getItem('currentPageForHome') || '1';
      const page_size = this.pageSize || localStorage.getItem('currentPageSizeForHome') || '20';
  
      this.apiService.retriveSentimentData(lang, current_page, page_size).subscribe({
        next: (response) => {
          try {
            if (response?.predictions) {
              this.textListData = response?.predictions || [];
              this.totalPages = Math.ceil(response.total_items / Number(page_size)) || 1;
            } else {
              console.error("Invalid response format: Missing 'data' key", response);
              this.textListData = [];
              this.totalPages = 1;
            }
          } catch (processingError) {
            console.error("Error while processing response:", processingError);
            this.textListData = [];
            this.totalPages = 1;
          } finally {
            this.globalService.dismissLoading(); // Hide loading indicator
          }
        },
        error: (err) => {
          console.error("API call failed:", err);
          this.textListData = [];
          this.totalPages = 1;
          this.globalService.dismissLoading(); // Hide loading on error
        }
      });
    } catch (setupError) {
      console.error("An error occurred before the API call:", setupError);
      this.textListData = [];
      this.totalPages = 1;
      this.globalService.dismissLoading(); // Hide loading on setup error
    }
  }

  async onOptionChange($event: IonSelectCustomEvent<SelectChangeEventDetail<any>>) {
          this.currentPage = 1;
          this.globalService.logoutLoading();
          const updateLang = $event.detail.value;
          this.selectedOption = updateLang;
          localStorage.setItem('langCategory', updateLang);
          await this.fetchTextList();
          
      }

  
  onPageSizeChange(){
    this.currentPage = 1;
    console.log("Page size is:",this.pageSize);
    //make API call for retriveText()
    localStorage.setItem('currentPageSizeForHome',this.pageSize.toString());
    this.fetchTextList();
    
  }
  

  goToFirstPage(){
    console.log("go to first page");
    this.currentPage = 1;

    //make API call for retriveText()
    localStorage.setItem('currentPageForHome',this.currentPage.toString());
    this.fetchTextList();
    console.log("First Page is:",this.currentPage)
  }

  prevPage(): void{
    console.log("go to previous page");
    if (this.currentPage > 1) {
      this.currentPage--;

      //make API call for retriveText()
      localStorage.setItem('currentPageForHome',this.currentPage.toString());
      this.fetchTextList();
      console.log("Previous Page is:",this.currentPage)
    }
  }
  nextPage(): void{
    console.log("go to next page");
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      
      //make API call for retriveText()
      this.fetchTextList();
      localStorage.setItem('currentPageForHome',this.currentPage.toString());

      console.log("Next Page is:",this.currentPage)
    }
  }
  goToLastPage(): void{
    console.log("go to last page");
    this.currentPage = this.totalPages;

    //make API call for retriveText()
    this.fetchTextList();
    localStorage.setItem('currentPageForHome',this.currentPage.toString());

    console.log("Last Page is:",this.currentPage)
  }

  goToSpecificPage(pageNumber: number): void{
    console.log("Go to specific page number is:",pageNumber);

    console.log("go to specific page");
    if (pageNumber >= 1 && pageNumber <= this.totalPages) {
      this.currentPage = pageNumber;
      // Any additional logic to handle page change

      //make API call for retriveText()
      this.fetchTextList();
      localStorage.setItem('currentPageForHome',this.currentPage.toString());

      console.log("Current Page is:",this.currentPage);
    }
  }


  async confirmLogout() {
    // if(this.isRecording || this.hasUnsavedAudioData()){  
      const alert = await this.alertController.create({
            header: 'Confirm Logout',
            message: 'Are you sure you want to log out?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        // Do nothing when the user cancels
                    }
                },
                {
                    text: 'Logout',
                    handler: async () => {
                        // this.stopRecordingOnly();
                        await this.LogoutFunction();
                    }
                }
            ]
        });

        await alert.present();
      // }else{
      //   await this.LogoutFunction();
      // }
  }

  async LogoutFunction(){
  
      try{
          this.globalService.logoutLoading();
          const res:any = await this.apiService.logoutUser().toPromise();
              

          localStorage.removeItem('authenticationKey');
          localStorage.removeItem('accent');
          localStorage.removeItem('age');
          localStorage.removeItem('gender');
          localStorage.removeItem('userId');
          localStorage.removeItem('userName');
          localStorage.removeItem('language');

          localStorage.removeItem('searchedText');
          localStorage.removeItem('selectedModel');
          localStorage.removeItem('selectedModelLanguageForTTS');
          localStorage.removeItem('selectedFilterValueForTTS');
          
          localStorage.removeItem('selectedOptionUser');
          localStorage.removeItem('textCategory');
          localStorage.removeItem('totalCountData');
          localStorage.removeItem('usersList');
          localStorage.removeItem('userRole');

          localStorage.removeItem('notRemoveModelInferencingData');
          localStorage.removeItem('numberOfRecordedText');
          localStorage.removeItem('numberOfTotalRecordedText');
          localStorage.removeItem('textCategory');
          localStorage.removeItem('langCategory');
  
          this.globalService.dismissLoading();
        
          this.router.navigate(['login']);



        
      
      }catch(error){
        console.log("Error:", error);
        // this.globalService.dismissLoading();
        this.router.navigate(['login']);

      }
      
  };





}
